export default __webpack_public_path__ + "static/media/spider-web.05c1c137874edaae9069ab2da3615549.jpg";